import { AxiosRequestConfig, AxiosResponse } from "axios";
import { Api } from "./Api";
import { apiConfig } from "../config/apiConfig";
import { SignUpRequest } from "../model/auth";

class AuthApi extends Api {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig);

    this.signIn = this.signIn.bind(this);
    this.signUp = this.signUp.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
  }

  public signIn = (payload: any) => this.post("/login", payload);

  public signUp = async (payload: SignUpRequest) =>
    await this.post("/register", payload)
      .then((response: AxiosResponse) => response);

  public signUpPrecogValidate = (payload: any, fields: string[]) =>
    this.post("/register", payload, {
      headers: {
        "Precognition": true,
        "Precognition-Validate-Only": fields.join(","),
      }
    });

  public updatePassword = async (payload: any) =>
    await this.put("/password", payload)
      .then((response: AxiosResponse) => response);

  public forgotPassword = async (payload: any) =>
    await this.post("/forgot_password", payload)
      .then((response: AxiosResponse) => response);

  public resetPassword = async (payload: any) =>
    await this.post("/reset_password", payload)
      .then((response: AxiosResponse) => response);

  public generateOtp = async (payload: any) =>
    await this.post("/generateOTP", payload)
      .then((response: AxiosResponse) => response);

  public verifyOtp = async (payload: any) =>
    await this.post("/verify_otp", payload)
      .then((response: AxiosResponse) => response);
}

export const authApi = new AuthApi(apiConfig);
